import React, { useState } from "react";
import { UncontrolledDropdown, Button } from "reactstrap";
import { Icon } from "../Component";
import miscService from "../../api/misc/misc";
import Swal from "sweetalert2";
import { Form, Modal as AntModal, Input } from "antd";
import { useDispatch } from "react-redux";
import { setHighlight } from "../../store/slices/misc/highlightSlice";
import { Link } from "react-router-dom";
import ExportToXlsx from "../../utils/exportToXlsx";

// Define application types
export enum ApplicationType {
  Procurement = "Procurement",
  Pms = "PMS",
  Wom = "WOM",
}

const reportConfiguration: any = {
  "task-reassignment-reports-list": {
    reportType: "taskReassignment",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "task-aging-report": {
    reportType: "taskAging",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "checklist-adherence-by-user-report": {
    reportType: "checklistAdherence",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "onhold-tasks-report": {
    reportType: "onHoldTasksAndRootCause",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "approvals-action-delays-report": {
    reportType: "approvalActionDelays",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "tagwise-task-performance-report": {
    reportType: "tagWiseTaskPerformance",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "statuswise-task-performance-report": {
    reportType: "statusWiseTaskPerformance",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "work-category-wise-task-performance-report": {
    reportType: "workCategoryWiseTaskPerformance",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "phase-level-progress-summary-report": {
    reportType: "phaseLevelProgressSummaryReport",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "task-completion-report": {
    reportType: "taskCompletionReport",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "task-issue-tracker": {
    reportType: "taskAndIssueTracker",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "baseline-current-timeline-report": {
    reportType: "baseLineVsCurrentTimeline",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "dependency-violation-report": {
    reportType: "dependencyVoilationReport",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "userwise-workload-report": {
    reportType: "userWiseWorkloadReport",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "userwise-planned-actuals-report": {
    reportType: "userWisePlannedVsActual",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "time-log-reports": {
    reportType: "timeLogReport",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "daily-progress-digest": {
    reportType: "dailyProgressDigest",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "task-wise-timelogs": {
    reportType: "taskWiseTimeLog",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  // EXTRA REPORTS
  "activity-wise-timelogs": {
    reportType: "activityWiseTimeLog",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "phase-wise-timelogs": {
    reportType: "phaseWiseTimeLog",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "checklist-adherence-report": {
    reportType: "checklistAdherence",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "dependency-violation-list": {
    reportType: "dependencyVoilationList",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "checklist-adherence-count": {
    reportType: "countListForChecklistAdherenceByUser",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "tag-list-performance": {
    reportType: "tagListForTagWiseTaskPerformance",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "overdue-workload-count": {
    reportType: "overDueCountListForUserWiseWorkLoad",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "delayed-days-status-performance": {
    reportType: "delayedDaysStatusWiseTaskPerformance",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "overdue-work-category-report": {
    reportType: "overDueWorkCategoryWiseTaskReport",
    reportModule: "pmsReports",
    applicationType: ApplicationType.Pms,
  },
  "project/timesheet": {
    reportType: "Task TimeLog list",
    reportModule: "pmsTimeSheet",
    applicationType: ApplicationType.Pms,
  },
  "project/tasks": {
    reportType: "Task list",
    reportModule: "pmsTasks",
    applicationType: ApplicationType.Pms,
  }
};

const Export = ({
  data,
  moduleKey,
  reportType = "pmsReports",
  showAsButton = true,
}: {
  data: any;
  moduleKey?: any;
  reportType?: any;
  showAsButton?: boolean;
}) => {
  const dispatch = useDispatch();
  const params = data;
  const [showCommentsModal, setShowCommentsModal] = useState(false);

  // console.log("Export component received moduleKey:", moduleKey);
  // console.log(
  //   "Available reportConfiguration keys:",
  //   Object.keys(reportConfiguration)
  // );

  const handelExcelClick = () => {
    if (!moduleKey) {
      ExportToXlsx(data, "Excel");
    }
    setShowCommentsModal(true);
  };

  const getExtraPaginationParams = (moduleKey: any) => {
    console.log("moduleKey", moduleKey);
    const {
      selectFilter1,
      selectFilter2,
      selectFilter3,
      siteId,
      materialId,
      categoryId,
      contractorId,
      supplierId,
      projectIds,
      orgIds,
      userIds,
      phaseIds,
      activityIds,
      baseLineIds,
      assignedToIds,
      taskIds,
      tagIds,
      taskOwnerIds,
      workCategoryIds,
      status,
      startDate,
      endDate,
    } = params;

    // console.log(params, 'params');

    // Only handle pmsReports from reportConfiguration
    if (
      reportConfiguration[moduleKey]?.applicationType === ApplicationType.Pms
    ) {
      return {
        projectIds: projectIds || undefined,
        taskOwnerIds: taskOwnerIds || undefined,
        phaseIds: phaseIds || undefined,
        activityIds: activityIds || undefined,
        baselineIds: baseLineIds || undefined,
        assignedToIds: assignedToIds || undefined,
        taskIds: taskIds || undefined,
        tagIds: tagIds || undefined,
        workCategoryIds: workCategoryIds || undefined,
        status: status || undefined,
        startDate: startDate || undefined,
        endDate: endDate || undefined,

        // Include existing parameters for backward compatibility
        contractorIds: contractorId || undefined,
        siteIds: siteId || undefined,
        supplierIds: supplierId || undefined,
        materialIds: materialId || undefined,
        categoryIds: categoryId || undefined,
      };
    }

    // Return empty object for invalid moduleKey
    // return {}
    // Procurement specific parameters (existing logic)
    return {
      contractorIds: contractorId ? contractorId : undefined,
      siteIds: siteId ? siteId : undefined,
      supplierIds: supplierId ? supplierId : undefined,
      materialIds: materialId ? materialId : undefined,
      categoryIds: categoryId ? categoryId : undefined,
    };
  };

  const comments = async (comments: any) => {
    try {
      // console.log("ModuleKey in comments function:", moduleKey);
      // console.log("Type of moduleKey:", typeof moduleKey);

      // if (moduleKey) {
      //   console.log("moduleKey starts with /pms/:", moduleKey.startsWith('/pms/'));
      //   console.log("moduleKey starts with /:", moduleKey.startsWith('/'));
      // }

      const normalizedKey = moduleKey
        ?.replace(/^\/pms\//, "")
        ?.replace(/^\//, "");
      // console.log("Normalized moduleKey:", normalizedKey);

      let reportConfig = reportConfiguration[normalizedKey];
      // console.log("Report config lookup:", reportConfig);

      if (!reportConfig) {
        const altKey = moduleKey?.replace(/^\/pms\//, "");
        reportConfig = reportConfiguration[altKey];
        // console.log("Alternative lookup (keep slash):", reportConfig);
      }

      if (!reportConfig && normalizedKey) {
        const keyWithoutTrailingId = normalizedKey.replace(/\/\d+$/, "");
        reportConfig = reportConfiguration[keyWithoutTrailingId];
      }

      if (!reportConfig) {
        console.error(
          "No report configuration found for moduleKey:",
          normalizedKey
        );
        Swal.fire({
          title: "Error",
          text: "Report configuration not found",
          icon: "error",
        });
        return;
      }

      const extraParams = getExtraPaginationParams(normalizedKey);

      // Prepare the payload
      const payload = {
        reportType: reportConfig.reportType,
        reportModule: reportConfig.reportModule,
        applicationType: reportConfig.applicationType,
        comments: comments,
        paginationData: {
          ...getExtraPaginationParams(normalizedKey),
          pageSize: params.pageSize,
          startDate:
            extraParams.startDate || params.startDate || params.dateRange?.from,
          endDate:
            extraParams.endDate || params.endDate || params.dateRange?.to,
          sortOrder: params.sortOrder,
          direction: params.direction,
          pageDiff: params.pageDiff,
          page: params.page || 1,
          searchQuery: params.searchQuery,
          // ...(reportType === "transactionFlow"
          //   ? {
          //       sortOrder: params.sortOrder,
          //       direction: params.direction,
          //       pageDiff: params.pageDiff,
          //       searchQuery: params.searchQuery,
          //     }
          //   : {
          //       page: params.page,
          //       contractorIds: params.contractorId || undefined,
          //       siteIds: params.siteId || undefined,
          //       supplierIds: params.supplierId || undefined,
          //       materialIds: params.materialId || undefined,
          //       categoryIds: params.categoryId || undefined,
          //     }),
        },
      };

      console.log("Export payload:", payload);

      const apiResponse = await miscService.excelExportRequest(payload);

      if (apiResponse?.status) {
        dispatch(setHighlight(true));
        Swal.fire({
          title: "Success",
          text: "Request Submitted Successfully",
          icon: "success",
        });
      }
    } catch (error) {
      // console.error("Error loading data:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to submit export request",
        icon: "error",
      });
    }
  };

  return (
    <>
      {showAsButton ? (
        <UncontrolledDropdown size={"md"}>
          {" "}
          <div
            onClick={() => handelExcelClick()}
            className="btn btn-white btn-outline-light"
          >
            <Icon name="download-cloud"></Icon>
            <span>Export </span>
          </div>
        </UncontrolledDropdown>
      ) : (
        <Link to={`#`} onClick={() => handelExcelClick()}>
          <Icon name="download-cloud"></Icon>
          <span>Export</span>
        </Link>
      )}
      {moduleKey && (
        <CommentsModal
          isModalVisible={showCommentsModal}
          setIsModalVisible={setShowCommentsModal}
          comments={comments}
        />
      )}
    </>
  );
};

const CommentsModal = ({
  isModalVisible,
  setIsModalVisible,
  comments,
}: any) => {
  const [form] = Form.useForm();

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const reason = values.reason;
        comments(reason); // Call your reject function here
        form.resetFields();
        setIsModalVisible(false);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };
  return (
    <AntModal
      title="Comments"
      visible={isModalVisible}
      footer={null} // Remove the default footer buttons
      onCancel={handleCancel}
    >
      <Form form={form} layout="vertical" name="rejectForm">
        <Form.Item
          name="reason"
          label="Comments"
          rules={[{ required: true, message: "Please input your Comments!" }]}
        >
          <Input.TextArea placeholder="Type your Comments here..." />
        </Form.Item>
        <div className="actions clearfix">
          <ul>
            <li>
              <Button color="primary" type="submit" onClick={handleOk}>
                Request
              </Button>
            </li>
            <li>
              <Button
                color="primary"
                onClick={handleCancel}
                className="btn-dim btn btn-secondary"
              >
                Cancel
              </Button>
            </li>
          </ul>
        </div>
      </Form>
    </AntModal>
  );
};

export default Export;
